export default "__VITE_ASSET__482e904c__"